import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import GridViewDetail from './Detail';
import GridViewThumbnail from './Thumbnail';

function getConfig(config) {
  var newConfig = _objectSpread({}, defaultConfig, config);

  newConfig.view = _objectSpread({}, defaultConfig.view, newConfig.view);
  if (!newConfig.count) newConfig.count = newConfig.data.length;
  if (!newConfig.view.page) newConfig.view.page = 0;
  return newConfig;
}

function getStyles(styles) {
  if (!styles) return defaultStyles;

  var newStyles = _objectSpread({}, defaultStyles, styles);

  return newStyles;
}
/**
 * @extends {React.Component<import('./types').DataGridViewProps> }
 */


var DataGridView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataGridView, _React$Component);

  function DataGridView() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataGridView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataGridView)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onItemClick = function (e, item) {
      if (!_this.props.onClick) return;

      _this.props.onClick(e, item);
    };

    _this.onItemDoubleClick = function (e, item) {
      if (!_this.props.onDoubleClick) return;

      _this.props.onDoubleClick(e, item);
    };

    return _this;
  }

  _createClass(DataGridView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChangePage = _this$props.onChangePage,
          onChangeItemsPerPage = _this$props.onChangeItemsPerPage,
          onChangeSort = _this$props.onChangeSort,
          onChangeFilter = _this$props.onChangeFilter,
          onChangeMode = _this$props.onChangeMode,
          hidePageSelector = _this$props.hidePageSelector,
          hideItemsPerPage = _this$props.hideItemsPerPage,
          hideModeSwitcher = _this$props.hideModeSwitcher,
          paginationStyle = _this$props.paginationStyle,
          config = _this$props.config,
          styles = _this$props.styles,
          rest = _objectWithoutProperties(_this$props, ["onChangePage", "onChangeItemsPerPage", "onChangeSort", "onChangeFilter", "onChangeMode", "hidePageSelector", "hideItemsPerPage", "hideModeSwitcher", "paginationStyle", "config", "styles"]);

      var gridConfig = getConfig(config);
      var gridStyles = getStyles(styles);
      var callbacks = {
        onChangePage: onChangePage,
        onChangeItemsPerPage: onChangeItemsPerPage,
        onChangeSort: onChangeSort,
        onChangeFilter: onChangeFilter,
        onChangeMode: onChangeMode,
        onItemClick: this.onItemClick,
        onItemDoubleClick: this.onItemDoubleClick
      };
      var paginationConfig = {
        hidePageSelector: hidePageSelector,
        hideItemsPerPage: hideItemsPerPage,
        hideModeSwitcher: hideModeSwitcher,
        paginationStyle: paginationStyle
      };

      if (gridConfig.view.mode === 'detail' || gridConfig.view.mode === 'list') {
        return React.createElement(GridViewDetail, Object.assign({}, paginationConfig, {
          config: gridConfig
        }, callbacks, {
          styles: gridStyles
        }, rest));
      } else if (gridConfig.view.mode === 'thumbnail') {
        return React.createElement(GridViewThumbnail, Object.assign({}, paginationConfig, {
          config: gridConfig
        }, callbacks, {
          styles: gridStyles
        }, rest));
      } else {
        throw new Error("Unsupported view mode ".concat(gridConfig.view.mode));
      }
    }
  }]);

  return DataGridView;
}(React.Component);

var defaultConfig = {
  view: {
    mode: 'detail',
    itemsPerPage: 10,
    page: 0,
    isLoading: false,
    error: null
  },
  count: 0,
  columns: [],
  thumbnail: {},
  data: [],
  idKeyProp: 'Id',
  hoverable: true,
  selectedKeyProp: '_selected'
};
var defaultStyles = {
  elevation: 2,
  tableLayoutAuto: false,
  hideBorder: false
};
DataGridView.defaultProps = {
  config: defaultConfig,
  styles: defaultStyles,
  hidePageSelector: false,
  hideItemsPerPage: false,
  hideModeSwitcher: false,
  thumbnailComponentProps: {},
  rowComponentProps: {}
};
export default DataGridView;